import {createApp} from 'vue'
import PostsList from './PostsList'

const el = '.kb-component--posts-list'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((PostsListDOM)=>{
            const groupData = JSON.parse(PostsListDOM.dataset.group)
            
            const props = {
                guid: PostsListDOM.dataset.guid ?? '',
                numberOfMembers: groupData.numberOfMembers ?? 0,
                groupId: groupData.id ?? '',
                isClosedGroup: groupData.isClosedGroup,
                universId: PostsListDOM.dataset.universId ?? '',
                isLoggedIn: PostsListDOM.dataset.isLoggedIn === "true",
                loginUrl: PostsListDOM.dataset.loginUrl,
                hasMemberAccess: PostsListDOM.dataset.hasMemberAccess === "true",
                take: parseInt(PostsListDOM.dataset.take)
            }
            const component = createApp(PostsList, props).use(Store)
            component.mount(PostsListDOM)
        })
    }
}